import { authInit } from './auth-initializer.provider';
import { localizeInit } from './i18n-initializer.provider';
import { iconsInit } from './icons-initializer.provider';

/**
 * Application initializer function.
 * This function initializes the core flows of the application, including
 * authentication and internationalization. It is designed to be used with
 * the `APP_INITIALIZER` provider to ensure these flows are set up during
 * the application startup phase.
 *
 * @remarks
 * - `authInit`: Initializes the authentication flow to set up user authentication.
 * - `localizeInit`: Initializes the internationalization (i18n) flow to handle
 *   localization and language settings.
 */
export const appInitializer = () => {
  // Initialize the internationalization process
  localizeInit();

  // Intialize importing custom icons process
  iconsInit();

  // Initialize the authentication process
  return authInit();
};
